import React from "react";
import { Rocket, Megaphone, Sparkles, ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

const SectionDivider = ({
  icon = "rocket",
  title = "Next Stage",
  description = "Scaling to new heights of monetization",
}) => {
  // Map icon string to Lucide component
  const iconMap = {
    rocket: Rocket,
    ads: Megaphone,
    spark: Sparkles,
    shield: ShieldCheck,
  };

  const IconComponent = iconMap[icon] || Rocket;

  return (
    <div className="relative flex flex-col items-center text-center my-24 px-6">
      {/* Pulsing animated line */}
      <motion.div
        className="w-full h-1 bg-gradient-to-r from-pink-500 via-indigo-500 to-purple-500 rounded-full blur-sm mb-6"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{ originX: 0 }}
      />

      {/* Floating Icon */}
      <motion.div
        className="bg-gradient-to-br from-indigo-500 to-pink-500 p-4 rounded-full text-white shadow-xl"
        animate={{
          y: [0, -8, 0],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <IconComponent className="w-8 h-8" />
      </motion.div>

      {/* Title & Description */}
      <motion.h3
        className="text-2xl sm:text-3xl font-bold mt-4 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-pink-600"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {title}
      </motion.h3>
      <motion.p
        className="text-gray-600 max-w-xl mt-2 text-sm sm:text-base"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        {description}
      </motion.p>
    </div>
  );
};

export default SectionDivider;
